/*eslint-disable*/
import { inView } from "../modules/inView";
import chroma from "chroma-js";

const d3 = Object.assign({}, require("d3-selection"), require("d3-shape"), require("d3-interpolate"), require("d3-transition"), require("d3-scale"), require("d3-axis"), require("d3-array"), require("d3-dsv"));

const color = {
    red: "#cb333b",
    orange: "#dc582a",
    purple: "#702f8a",
    "light-green": "#7fba00",
    "dark-green": "#008651",
    "light-blue": "#15bef0",
    "dark-blue": "#003865",
    "light-grey": "#cccccc",
    grey: "#60605b",
    default: "#1867b3",
    white: "#fff"
};

const tau = Math.PI * 2;
const angle = percentage => (percentage * tau) / 100;
const lineHeight = 1.1;
const defaultPad = 0.15;

function drawBarCharts() {

    let barCharts = document.querySelectorAll(".barChart__svg");

    barCharts.forEach((chart, i) => {
        let height, x, y, xAxis, yAxis, margin;
        let width = chart.offsetWidth;

        let jsonString = chart.getAttribute("data-json"),
            jsonReplace = jsonString.replace(/'/g, '"'),
            json = JSON.parse(jsonReplace),
            csv = json.data.replace(/<br\/>/g, "\n");

        let parsed = d3.csvParse(csv);

        let xCol = parsed.columns[0], // assumed string
            yCol = parsed.columns[1]; // assumed [convertable to] number

        let sortFn;
        if (json.sorted != "false") {
            if (json.sorted == "ascending") {
                sortFn = (a, b) => d3.ascending(+a[yCol], +b[yCol]);
            } else {
                sortFn = (a, b) => d3.descending(+a[yCol], +b[yCol]);
            }
        }

        let data = Object.assign(parsed.sort(sortFn), {format: "~" + (json.format || "s"), x: json.xLabel ? `→ ${json.xLabel}` : "", y: json.yLabel ? `↑ ${json.yLabel}` : "" });

        let isHorizontal = json.horizontal == "true" ? true : false;

        if (isHorizontal) {

            margin = { top: (+json.customMargins.top || 30), right: (+json.customMargins.right || 0), bottom: (+json.customMargins.bottom || 10), left: (+json.customMargins.left || 40) };

            let barHeight = Math.max(25, Math.min(80, width / data.length));
            height = Math.ceil((data.length + defaultPad) * barHeight) + margin.top + margin.bottom;
            
            x = d3.scaleLinear()
                .domain([0, d3.max(data, d => +d[yCol])]).nice()
                .rangeRound([margin.left, width - margin.right]);

            y = d3.scaleBand()
                .domain(d3.range(data.length))
                .range([margin.top, height - margin.bottom])   
                .paddingInner(defaultPad)
                .paddingOuter(0);

            xAxis = g => g
                .attr("class", "x axis")
                .attr("transform", `translate(0,${margin.top})`)
                .call(d3.axisTop(x).ticks(width / 80, data.format).tickSizeInner(8).tickSizeOuter(-10).tickPadding(8)) /* LABEL OPTIONS */
                // .call(g => g.select(".domain").remove()) // OPTION TO REMOVE AXIS LINE
                
            yAxis = g => g        
                .attr("class", "y axis")
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(y).tickFormat(i => data[i][xCol]).tickSizeInner(8).tickSizeOuter(0).tickPadding(8)) /* LABEL OPTION */
                // .call(g => g.select(".domain").remove()) // OPTION TO REMOVE AXIS LINE
                
        } else {

            margin = { top: (+json.customMargins.top || 30), right: (+json.customMargins.right || 5), bottom: (+json.customMargins.bottom || 50), left: (+json.customMargins.left || 40) };

            height = 0.5 * width;

            x = d3.scaleBand()
                .domain(d3.range(data.length))
                .range([margin.left, width - margin.right])
                .paddingInner(defaultPad)
                .paddingOuter(0);

            y = d3.scaleLinear()
                .domain([0, d3.max(data, d => +d[yCol])]).nice()
                .rangeRound([height - margin.bottom, margin.top]);

            xAxis = g => g    
                .attr("class", "x axis")
                .attr("transform", `translate(0,${height - margin.bottom})`)
                .call(d3.axisBottom(x).tickFormat(i => data[i][xCol]).tickSizeInner(8).tickSizeOuter(0).tickPadding(8))

            yAxis = g => g
                .attr("class", "y axis")
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(y).ticks(width/80, data.format).tickSizeInner(8).tickSizeOuter(-10).tickPadding(8))
                /* .call(g => g.select(".domain").remove()) */ // OPTION TO REMOVE AXIS LINE
                .call(g => g.append("text")
                    .attr("x", -margin.left)
                    .attr("y", -margin.bottom)
                    .attr("fill", "currentColor")
                    .attr("text-anchor", "start")
                    .text(data.y)
                );
        }
        
        let xFn = isHorizontal ? d => x(0) : (d, i) => x(i);
        let yFn = isHorizontal ? (d, i) => y(i) : d => y(d[yCol]);
        let heightFn = isHorizontal ? y.bandwidth() : d => y(0) - y(d[yCol]);
        let widthFn = isHorizontal ? d => x(d[yCol]) - x(0) : x.bandwidth();
        let barClass = isHorizontal ? "horizontal" : "vertical";

        let svg = d3.select(chart).append("svg")
            .attr("id", `barChart-${i}`)
            .attr("viewBox", [0, 0, width, height]);

        svg.append("g")
            .attr("class", `${barClass} bars`)
            .selectAll(".bar")
                .data(data)
            .enter().append("rect")
                .attr("class", "bar")
                .attr("fill", color[json.colorName])
                .attr("x", xFn)
                .attr("y", yFn)
                .attr("height", heightFn)
                .attr("width", widthFn);
                
        let pinValues = json.pinValues == "false" ? false : json.pinValues;
        if (pinValues) {
            // let pinLocation = isHorizontal ? "right" : "top";
            let xTextFn = isHorizontal ? d => x(+d[yCol]) : (d, i) => x(i) + x.bandwidth() / 2;
            let yTextFn = isHorizontal ? (d, i) => y(i) + y.bandwidth() / 2 : d => y(+d[yCol]);
            let dx = isHorizontal ? -y.bandwidth() / 5 : 0;
            let dy = isHorizontal ? "0.35em" : "1.5em";
            let textFormat = isHorizontal ? d => x.tickFormat(200, data.format)(+d[yCol]) : d => y.tickFormat(200, data.format)(+d[yCol]);
            let defaultTextAnchor = isHorizontal ? "end" : "middle";

            let text = svg.append("g")
                    .attr("class", "pinnedValues")
                .selectAll("text")
                    .data(data)
                .join("text")
                    .attr("x", xTextFn)
                    .attr("y", yTextFn)
                    .attr("dx", dx)
                    .attr("dy", dy)                
                    .attr("text-anchor", defaultTextAnchor)
                    .text(textFormat)

            let textFilterFn = null;
            if (pinValues == "inner") {
                textFilterFn = isHorizontal ? d => x(+d[yCol]) - x(0) < 50 : d => y(0) - y(+d[yCol]) < 30;
            } else {
                textFilterFn = d => d;
            }
            
            // outerTop values
            let textFilter = function(text) {
                text.filter(textFilterFn)
                    .attr("dy", "-0.3em")
                    .style("fill", "#000")
            }

            // outerRight values
            let horzTextFilter = function(text) {
                text.filter(textFilterFn)
                    .attr("dx", -dx)
                    .attr("text-anchor", "start")
                    .style("fill", "#000")
            }

            text.call(isHorizontal ? horzTextFilter : textFilter)  // bars too short, force outer pin        
        }

        if (isHorizontal) {
            svg.append("g").call(xAxis);
 
            svg.append("g").call(yAxis)
                .selectAll(".tick text")
                    .call(wrap, margin.left * 2, y.bandwidth(), true); // true = isHorizontal;
        } else {
            svg.append("g").call(xAxis)
                .selectAll(".tick text")
                    .call(wrap, x.bandwidth() * 0.9, margin.bottom);

            svg.append("g").call(yAxis);
        }
    });
}

function drawStackedBarCharts() {

    let stackedBarCharts = document.querySelectorAll(".stackedBarChart__svg");

    stackedBarCharts.forEach((chart, i) => {
        let height, x, y, xAxis, yAxis, series;
        let width = chart.offsetWidth;

        let jsonString = chart.getAttribute("data-json"),
            jsonReplace = jsonString.replace(/'/g, '"'),
            json = JSON.parse(jsonReplace),
            csv = json.data.replace(/<br\/>/g, "\n");

        let name = csv.split(",")[0];

        let sortFn;
        if (json.sorted != "false") {
            /* TODO: ADD OPTION TO SORT BY TYPE VS TOTAL */
            if (json.sorted == "ascending") {
                sortFn = (a, b) => d3.ascending(+a.total, +b.total);
            } else {
                sortFn = (a, b) => d3.descending(+a.total, +b.total);
            }
        }

        let parsed = d3.csvParse(csv, (d, i, columns) => (d3.autoType(d), d.total = d3.sum(columns, c => d[c]), d)).sort(sortFn);
        let data = Object.assign(parsed, {axisFormat: "~" + (json.axisFormat || "s"), labelFormat: "~" + (json.labelFormat || "s"), x: json.xLabel ? `→ ${json.xLabel}` : "", y: json.yLabel ? `↑ ${json.yLabel}` : "" });

        let isHorizontal = json.horizontal == "true" ? true : false;
        let isNormalized = json.normalized == "true" ? true : false;
        let hideX = json.hideX == "true" ? true : false;
        let hideY = json.hideY == "true" ? true : false;

        let margin = { top: 30, right: 5, bottom: hideX ? 0 : 50, left: hideY ? 0 : 40 };
        let formatValue = x => isNaN(x) ? "N/A" : x.toLocaleString("en");
        let formatPercent = x => parseFloat((x * 100).toFixed(2)) + "%";
        let textLabelFn = data.labelFormat.includes("%") ? d => formatPercent(d[1] - d[0]) : d => formatValue(d.data[d.key]);

        if (isNormalized) {
            series = d3.stack()
                .keys(parsed.columns.slice(1))
                .offset(d3.stackOffsetExpand)(parsed)
                .map(d => (d.forEach(v => v.key = d.key), d));
        } else {
            series = d3.stack()
                .keys(parsed.columns.slice(1))(parsed)
                .map(d => (d.forEach(v => v.key = d.key), d));
        }
       
        let chosenColors = json.colors.split(",").map(d => color[d]);
        let colorArray = chroma.scale(chosenColors).colors(series.length);

        let colorScale = d3.scaleOrdinal()
            .domain(series.map(d => d.key))
            .range(colorArray)
            .unknown("#ccc");

        if (isHorizontal) {

            margin = { top: hideX ? 10 : 30, right: 0, bottom: 10, left: hideY ? 0 : 30 };

            let barHeight = Math.max(25, Math.min(80, width / data.length));
            height = Math.ceil((data.length + defaultPad) * barHeight) + margin.top + margin.bottom;

            x = d3.scaleLinear()
                .rangeRound([margin.left, width - margin.right]);

            if (!isNormalized) {
                x.domain([0, d3.max(series, d => d3.max(d, d => d[1]))]).nice();
            }

            y = d3.scaleBand()
                .domain(data.map(d => d[name]))
                .range([margin.top, height - margin.bottom])
                .paddingInner(defaultPad)
                .paddingOuter(0);

            xAxis = g => g
                .attr("class", "x axis")
                .attr("transform", `translate(0,${margin.top})`)
                .call(d3.axisTop(x).ticks(json.rangeTicks || (width / 100), data.axisFormat).tickSizeInner(8).tickSizeOuter(0).tickPadding(4))

            yAxis = g => g
                .attr("class", "y axis")
                .attr("transform", `translate(${margin.left},0)`)
                .call(d3.axisLeft(y).ticks(null, data.axisFormat).tickSizeInner(8).tickSizeOuter(0).tickPadding(4))
                .call(g => g.selectAll(".domain").remove()) // OPTION TO REMOVE AXIS LINE

        } else {

            height = 0.5 * width;

            x = d3.scaleBand()
                .domain(data.map(d => d[name]))
                .range([margin.left, width - margin.right])
                .paddingInner(defaultPad)
                .paddingOuter(0);

            y = d3.scaleLinear()
                .rangeRound([height - margin.bottom, margin.top])

            if (!isNormalized) {
                y.domain([0, d3.max(series, d => d3.max(d, d => d[1]))]).nice();
            }

            xAxis = g => g
                .attr("class", "x axis")
                .attr("transform", `translate(0,${height - margin.bottom})`)
                .call(d3.axisBottom(x).ticks(null, data.axisFormat).tickSizeInner(8).tickSizeOuter(0).tickPadding(4))
                // xAxis.call(g => g.selectAll(".domain").remove()); // OPTION TO REMOVE AXIS LINE

            yAxis = g => g
                .attr("class", "y axis")
                .attr("transform", `translate(${margin.left},-0.5)`)
                .call(d3.axisLeft(y).ticks(json.rangeTicks || (height / 100), data.axisFormat).tickSizeInner(8).tickSizeOuter(0).tickPadding(4))
                /* .call(g => g.selectAll(".domain").remove()) */ // OPTION TO REMOVE AXIS LINE
                .call(g => g.append("text")
                        .attr("x", -margin.left)
                        .attr("y", -margin.bottom)
                        .attr("fill", "currentColor")
                        .attr("text-anchor", "start")
                        .text(data.y)
                    );
        }

        let xFn = isHorizontal ? d => x(d[0]) : d => x(d.data[name]);
        let yFn = isHorizontal ? d => y(d.data[name]) : d => y(d[1]);
        let heightFn = isHorizontal ? y.bandwidth() : d => y(d[0]) - y(d[1]);
        let widthFn = isHorizontal ? d => x(d[1]) - x(d[0]) : x.bandwidth();
        let barClass = isHorizontal ? "horizontal" : "vertical";

        let svg = d3.select(chart).append("svg")
            .attr("id", `stackedBarChart-${i}`)
            .attr("viewBox", [0, 0, width, height]);

        svg.append("g")
            .attr("class", `${barClass} bars`)
            .selectAll(".bar")
                .data(series)
            .join("g")
                .attr("class", "bar")
                .attr("fill", d => colorScale(d.key))
                .selectAll(".barLayer")
                    .data(d => d)
                .join("rect")
                    .attr("class", "barLayer")
                    .attr("x", xFn)
                    .attr("y", yFn)
                    .attr("height", heightFn)
                    .attr("width", widthFn)
                    .append("title")
                        .text(d => `${d.key}: ${textLabelFn(d)}`); /* tooltip */

        let pinValues = json.pinValues == "false" ? false : json.pinValues;
        if (pinValues == "labels") {
            let xTextFn = isHorizontal ? d => x(+d[1]) - widthFn(d)/2: d => x(d.data[name]) + x.bandwidth() / 2;
            let yTextFn = isHorizontal ? d => y(d.data[name]) + y.bandwidth() / 2 : d => y(+d[1]) + heightFn(d)/2;
            let dx = 0;
            let dy = "0.35em";

            let oversized;
            if (isHorizontal) {
                oversized = function(d) {
                    return widthFn(d) < this.getBBox().width;
                };
            } else {
                oversized = function(d) {
                    return heightFn(d) < this.getBBox().height;
                };
            }

            let labels = svg.append("g") 
                .attr("class", "pinnedValues")
                .selectAll(".labelGroup")
                    .data(series)
                .join("g")
                    .attr("class", "labelGroup")
                    .selectAll(".layer")
                        .data(d => d)
                    .join("text")
                        .attr("class", "label")
                        .attr("x", xTextFn)
                        .attr("y", yTextFn)
                        .attr("dx", dx)
                        .attr("dy", dy)
                        .attr("text-anchor", "middle")
                        .text(textLabelFn)
                        .call(text => text.filter(oversized).style("display", "none"));
        } /* TODO: else if (pinValues == "totals") {} */

        if (isHorizontal) {
            svg.append("g").call(xAxis);
 
            svg.append("g").call(yAxis)
                .selectAll(".tick text")
                    .call(wrap, margin.left * 2, y.bandwidth(), true); // true = isHorizontal
        } else {
            svg.append("g").call(xAxis)
                .selectAll(".tick text")
                    .call(wrap, x.bandwidth() * 0.9, margin.bottom);

            svg.append("g").call(yAxis);
        }

        let legendDiv = chart.nextElementSibling;
        if (legendDiv) {
            drawLegend(legendDiv, colorScale);
        } else {
            d3.select(".stackedBarChart__legend").classed("hide", true);
        }
    });
}

function drawLegend(legendDiv, colorScale) {
    let length0 = colorScale.domain()[0].length;
    let sameLength = colorScale.domain().every(d => d.length == length0);

    let legendItems = d3.select(legendDiv).select(".legend__content")
            .classed("legend__content--sameLength", sameLength)
        .selectAll(".legendItem")
            .data(colorScale.domain())
        .join("div")
            .classed("legendItem", true)

    legendItems.append("span")
        .classed("legendItem__swatch", true)
        .style("background", d => colorScale(d));

    legendItems.append("span")
        .classed("legendItem__text", true)
        .text(d => d);
}

function drawDonutCharts() {
    let donutCharts = document.querySelectorAll(".donutChart__svg");

    donutCharts.forEach((chart, i) => {
        let width = chart.offsetWidth,
            radius = width / 2,
            girth = width * 0.15,
            fontSize = Math.max(1,Math.min(2.5, width/100));

        let arc = d3.arc()
            .startAngle(0)
            .innerRadius(radius - girth)
            .outerRadius(radius);

        const arcTween = function(targetAngle) {
            return function(d) {
                var interpolate = d3.interpolate(d.endAngle, targetAngle);
                return function(t) {
                    d.endAngle = interpolate(t);
                    return arc(d);
                };
            };
        };

        const labelTween = function(targetValue) {
            return function(d) {
                var interpolate = d3.interpolate(d, targetValue);
                return function(t) {
                    d = interpolate(t);
                    return d.toFixed()
                        .toLocaleString()
                        .concat("%");
                };
            };
        };

        let jsonString = chart.getAttribute("data-json"),
            jsonReplace = jsonString.replace(/'/g, '"'),
            json = JSON.parse(jsonReplace);

        let svg = d3.select(chart).append("svg")
            .attr("id", `donut-${i}`)
            .attr("viewBox", [-radius, -radius, radius * 2, radius * 2]);

        let g = svg.append("g");

        g.append("path")
            .datum({ endAngle: tau })
            .style("fill", "#3c3c3c")
            .attr("d", arc);

        let visArc = g.append("path")
            .datum({ endAngle: 0 }) /* pre-transition */
            .style("fill", color[json.colorName])
            .attr("d", arc);

        let text = g.append("text")
            .attr("text-anchor", "middle")
            .attr("font-family", "sans-serif")
            .attr("font-weight", "bold")
            .attr("font-size", fontSize + "em")
            .attr("fill", color[json.textColor])
            .attr("y", fontSize * 5)
            .datum(0) /* pre-transition  */
            .text(d => d.toLocaleString())

        let triggerTransition = function(selection) {
            selection.transition().duration(1500)
                .textTween(labelTween(json.percentage))
                .on("start", () => {
                    visArc.transition()
                        .duration(1500)
                        .attrTween("d", arcTween(angle(json.percentage)));
                });
        }

        if (inView(svg.node())) {
            triggerTransition(text)
        } else {
            d3.select(window).on(`scroll.donut-${i}`, () => {
                if (inView(svg.node())) {
                    triggerTransition(text);                    
                    d3.select(window)
                        .on(`scroll.donut-${i}`,null)
                }
            })
        }
    });
}

function drawPieCharts() {
    const pieSVG = document.querySelectorAll(".pieChart__svg");
    const legendList = document.querySelectorAll(".pieChart__list");

    pieSVG.forEach((chart, key) => { 
        const pieChartContainer =  document.querySelectorAll(".pieChart")[key];
        const legendCont = document.querySelectorAll(".pieChart__legendHolder")[key];

        if (pieChartContainer.offsetWidth < 370) legendCont.style.width = "100%";

        let jsonString = chart.dataset.json,
            jsonReplace = jsonString.replace(/'/g, '"'),
            json = JSON.parse(jsonReplace),
            csv = json.data.replace(/<br\/>/g, "\n");

        let parsed = d3.csvParse(csv);
        let {sorted, chartType, colors, sortBy} = json;
        let colorArr = colors.split(", ").filter(val => val !== "");
        let valueCol = parsed.columns[sortBy || 1]; // assumed [convertable to] number
        let sortFn;

        if (sorted != "false") {
            if (sorted == "ascending") {
                sortFn = (a, b) => d3.ascending(+a[valueCol], +b[valueCol]);
            } else {
                sortFn = (a, b) => d3.descending(+a[valueCol], +b[valueCol]);
            }
        }

        let pie,
            pieBool = chartType === "pie";

        if(pieBool) {
            pie = d3.pie()
                    .sort(sortFn)
                    .value(d => d.value);
        } else {
            pie = d3.pie()
                    .padAngle(0.005)
                    .sort(null)
                    .value(d => d.value);
        }
        
        const data = Object.assign(parsed.sort(sortFn));
        const arcs = pie(data);
        let legendItem = "";

        const sum = data.map(val =>val.value).reduce((a, b) => Number(a) + Number(b));
        
        let colorsArrUse = [];

        data.forEach(({name, value}, key) => {
            let randomizer = `#${(0x1000000+(Math.random())*0xffffff).toString(16).substr(1,6)}`;
            
            colorsArrUse.push(color[colorArr[key]] || randomizer);

            legendItem += `<li class="pieChart__item">
                                <div class="pieChart__itemContent">
                                    <div class="pieChart__color" style="background: ${colorsArrUse[key]}"></div>
                                    <div class="pieChart__name">
                                        ${name}
                                    </div>
                                </div>
                            </li>`;
        });

        legendList[key].innerHTML = legendItem;

        if (pieChartContainer.offsetWidth < 370) {
            if (window.innerWidth > 900 && window.innerWidth < 1025) {
                legendCont.querySelectorAll(".pieChart__color").forEach(pColor => {
                    pColor.classList.add("pieChart__color--small");
                });
            }
        }

        let width = chart.offsetWidth,
            height = Math.min(width, 500),
            arc,
            arcLabel,
            pieRadius;
        
        if (pieBool) {
            arc = d3.arc()
                    .innerRadius(0)
                    .outerRadius(Math.min(width, height) / 2 - 1);

            pieRadius = Math.min(width, height) / 2 * 0.8;
            arcLabel = d3.arc().innerRadius(pieRadius).outerRadius(pieRadius);

            let svg = d3.select(chart)
                .append("svg")
                .attr("viewBox", [-width / 2, -height / 2, width, height]);
    
            svg.append("g")
                .attr("stroke", "white")
                .selectAll("path")
                .data(arcs)
                .join("path")
                .attr("fill", d => colorsArrUse[d.index])
                .attr("d", arc)
                .append("title")
                .text(d => `${d.data.name}: ${d.data.value.toLocaleString()}`);
            
            svg.append("g")
                .attr("font-family", "sans-serif")
                .attr("font-size", 12)
                .attr("text-anchor", "middle")
                .selectAll("text")
                .data(arcs)
                .join("text")
                .attr("transform", d => `translate(${arcLabel.centroid(d)})`)
                .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
                    .attr("x", 0)
                    .attr("y", "0.7em")
                    .attr("fill-opacity", 0.8)
                    .attr("font-weight", "bold")
                    .attr("font-size", "15px")
                    .attr("fill", "#ffffff")
                    .text(d => `${((d.data.value / sum) * 100).toFixed(0)}%`));
        } else {            
            pieRadius = Math.min(width, height) / 2;      
            arc = d3.arc().innerRadius(pieRadius * 0.67).outerRadius(pieRadius - 1);

            let svg = d3.select(chart)
                .append("svg")
                .attr("viewBox", [-width / 2, -height / 2, width, height]);
    
            svg.selectAll("path")
                .data(arcs)
                .join("path")
                  .attr("fill", d => colorsArrUse[d.index])
                  .attr("d", arc)
                .append("title")
                  .text(d => `${d.data.name}: ${d.data.value.toLocaleString()}`);
            
            svg.append("g")
                .attr("font-family", "sans-serif")
                .attr("font-size", 12)
                .attr("text-anchor", "middle")
                .selectAll("text")
                .data(arcs)
                .join("text")
                .attr("transform", d => `translate(${arc.centroid(d)})`)
                .call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
                    .attr("x", 0)
                    .attr("y", "0.7em")
                    .attr("fill-opacity", 0.8)
                    .attr("font-weight", "bold")
                    .attr("fill", "#ffffff")
                    .attr("font-size", "15px")
                    .text(d => `${((d.data.value / sum) * 100).toFixed(0)}%`));
        }

    });
}

function wrap(labels, width, height, isHorizontal = false) {

    /* if (!isHorizontal) width -= 10; */ /* OPTION extraWrap */
    
    let parentNode = labels.node().parentNode,
        parentSvg = d3.select(parentNode.closest("svg"));
    
    if (isHorizontal) width = Math.min(width, parentSvg.node().closest(".dataVisualization__main").getBoundingClientRect().width * 0.5);  // don't allow labels to take up more than 50% of parent width

    let extraLines = 0,    
        baseFontSize = parseFloat(getComputedStyle(parentNode).fontSize),
        currentFontSize = baseFontSize,
        wiggleRoom = isHorizontal ? (width * 0.25) : (width * defaultPad),
        maxWidth = width + wiggleRoom;

    // adjust font-size as needed
    let sorted = labels.nodes().sort((a, b) => {
        let aVal = a.getComputedTextLength();
        let bVal = b.getComputedTextLength();
        return bVal < aVal ? -1 : bVal > aVal ? 1 : bVal >= aVal ? 0 : NaN;
    });
    
    let lineHeightEm = lineHeight + defaultPad;
    let lineHeightPx = baseFontSize * lineHeightEm;
    let maxLines = isHorizontal ? Math.floor(height / lineHeightPx) : 5;  // at full font-size; 5 is arbitrary
    let maxTextLength = sorted[0].getComputedTextLength();
    let maxLinesNeeded = Math.ceil(maxTextLength / width);

    while ((maxLinesNeeded > maxLines) && (currentFontSize > 4)) { // arbitrary min
        labels.style("font-size", --currentFontSize + "px");

        if (isHorizontal) {            
            lineHeightPx = currentFontSize * lineHeightEm;
            maxLines = Math.floor(height / lineHeightPx); // at current font-size
        }

        maxTextLength = sorted[0].getComputedTextLength();
        maxLinesNeeded = Math.ceil(maxTextLength / width);
    }

    labels.each(function () {
        // go through labels and divide text into linesNeeded
        let linesNeeded = Math.ceil(this.getComputedTextLength() / width);

        var text = d3.select(this),
            words = text.text().replace(/[\u2012\u2013\u2014\u2015]/g, '-').trim().split(/([\s\-])/g).reverse(),
            line = [words.pop()],
            lineNumber = 0,
            x = text.attr("x") || 0,
            y = text.attr("y"),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null)
                        .append("tspan")
                        .classed("textLabel",true)
                        .attr("x", x)
                        .attr("y", y)
                        .attr("dy", dy + "em");

        while (words.length > 0) {
            let word = words.pop();
            line.push(word);
            tspan.text(line.join(""));

            if (word != "-" && (lineNumber + 1) < linesNeeded && tspan.node().getComputedTextLength() > maxWidth) {
                words.push(line.pop()) // remove and store rejected addition
                tspan.text(line.join("").trim()); // resave and trim final text
                line = [];  // start fresh
                tspan = text.append("tspan")
                            .attr("x", x)
                            .attr("y", y)
                            .attr("dy", ++lineNumber * lineHeight + dy + "em")
                            .text(null);
            }
        }

        if (!isHorizontal) extraLines = Math.max(extraLines, lineNumber);  // track cumulative max

        tspan.text(line.join("").trim()); // trim final line, too

        if (isHorizontal && lineNumber > 0) {
            let lineAdjust = lineHeight / 2;

            this.childNodes.forEach((node, i) => {
                let tspan = d3.select(node);

                if (i == 0) {
                    tspan.attr("dy", (-1 * lineNumber * lineAdjust + "em"));
                } else {
                    tspan.attr("dy", lineHeight + dy + "em");
                }
            })
        }
    });

    if (extraLines > 0) {
        let marginBottom = extraLines * lineHeight * currentFontSize + "px";
        parentSvg.style("margin-bottom", marginBottom)
    }
}

function init() {
    drawPieCharts();
    drawDonutCharts();
    drawBarCharts();
    drawStackedBarCharts();
}

export default { init };

/* TODO: add resize listeners */
/* TODO: add custom margin options to stackedBarChart, more? */
/* TODO: add option to manage maxLines on standard-orientation labels */